import { Component, ElementRef, Renderer2, inject } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';

@Component({
  selector: 'app-switcher',
  standalone:false,
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
})
export class SwitcherComponent {
  active = 1;
  public localdata: any ;
  constructor(
    private elementRef: ElementRef,
    private appStateService: AppStateService,
    private renderer: Renderer2
  ) {
    this.appStateService.state$.subscribe(state => {
      this.localdata = state;
    });
  }

  updateDirection(direction: string) {
    this.appStateService.updateState({ direction });
  }

  updateTheme(theme: string) {
    this.appStateService.updateState({ theme, menuColor: theme, headerColor: theme });
    if (theme == 'light') {
      this.appStateService.updateState({ theme, themeBackground: '', headerColor: 'transparent', menuColor: 'light' });
      let html = document.querySelector('html');
      html?.style.removeProperty('--body-bg');
      html?.style.removeProperty('--dark-bg');
      html?.style.removeProperty('--light');
      html?.style.removeProperty('--gray-3');
      html?.style.removeProperty('--input-border');
      localStorage.removeItem('hs-theme')
    }
    if (theme == 'dark') {
      this.appStateService.updateState({ theme, themeBackground: '', headerColor: 'transparent', menuColor: 'dark' });
      let html = document.querySelector('html');
      html?.style.removeProperty('--body-bg');
      html?.style.removeProperty('--dark-bg');
      html?.style.removeProperty('--light');
      html?.style.removeProperty('--gray-3');
      html?.style.removeProperty('--input-border');
      localStorage.removeItem('hs-theme')
    }
  }
  updatemenuType(navigationStyles: string) {
    this.appStateService.updateState({ navigationStyles });
    const currentMenuStyles = this.appStateService.getState('menuStyles') || '';

    if (navigationStyles == 'horizontal') {
      // Set default 'menu-click' if nothing else is set
      this.appStateService.updateState({ navigationStyles,menuStyles:'menu-click', layoutStyles: '' });
      this.checkMenuElement(currentMenuStyles);  // Use the default style
    //  
      setTimeout(() => {
        const mainContentElement = document.querySelector(".main-content") as HTMLElement | null;
        if (mainContentElement) {
            mainContentElement.click();
        }
      }, 100);
    } else if(navigationStyles == 'vertical'){
      this.appStateService.updateState({ navigationStyles, menuStyles: '', layoutStyles: 'default' });
    }
}

private checkMenuElement(menuStyles: string) {
  // Define element IDs based on menuStyles
  const elementIds: { [key: string]: string } = {
    'menu-click': 'switcher-menu-click',
    'menu-hover': 'switcher-menu-hover',
    'icon-hover': 'switcher-icon-hover',
    'icon-click': 'switcher-icon-click',

  };
  // Get the corresponding element ID
  const elementId = elementIds[menuStyles];

  if (elementId) {
    const menuElement = document.getElementById(elementId) as HTMLInputElement;
    if (menuElement) {
      menuElement.checked = true;
    }
    else{
          const menuclickclosed = document.getElementById('switcher-menu-click') as HTMLInputElement;
          menuclickclosed.checked = true;
    }
  }
}
  updatemenuStyle(menuStyles: string) {
    this.appStateService.updateState({ menuStyles, layoutStyles: '' });
      const navStyle = document.documentElement.getAttribute('data-nav-style');
 
      if(navStyle === 'icon-hover'){
        document.querySelector('.double-menu-active')?.setAttribute('style', 'display: none;');
        const Sidebar: any = document.querySelector(".main-menu");
        if (Sidebar) {
            Sidebar.style.marginInline = "0px";
        }
      }  
      if(navStyle === 'icon-click'){
        const Sidebar: any = document.querySelector(".main-menu");
        if (Sidebar) {
            Sidebar.style.marginInline = "0px";
        }
      }
  }

  updatelayoutStyles(layoutStyles: string) {
    this.appStateService.updateState({ layoutStyles, menuStyles: '',navigationStyles:'' });
    if (document.querySelector('html')?.getAttribute('data-vertical-style') == 'doublemenu') {
      document.querySelector('.slide-menu')?.classList.add('double-menu-active');
       }
       else{
        document.querySelector('.slide-menu')?.classList.remove('double-menu-active');
       }
  }
  setAttr(key: string, value: string): void {
    const htmlElement = this.elementRef.nativeElement.ownerDocument.documentElement;
    this.renderer.setAttribute(htmlElement, key, value);
    return;
  }
  removeAttr(key: string): void {
    const htmlElement = this.elementRef.nativeElement.ownerDocument.documentElement;
    this.renderer.removeAttribute(htmlElement, key);
    return;
  }
  updatepageStyles(pageStyles: string) {
    this.appStateService.updateState({ pageStyles });
  }
  updatewidthStyles(widthStyles: string) {
    this.appStateService.updateState({ widthStyles });
  }
  updatemenuPosition(menuPosition: string) {
    this.appStateService.updateState({ menuPosition });
  }
  updateheaderPosition(headerPosition: string) {
    this.appStateService.updateState({ headerPosition });
  }
  updatemenuColor(menuColor: string) {
    this.appStateService.updateState({ menuColor });
  }
  updateheaderColor(headerColor: string) {
    this.appStateService.updateState({ headerColor });
  }
  updateprimary(themePrimary: any) {
    this.appStateService.updateState({ themePrimary });
  }
  updateprimary1(themePrimary1: any) {
    this.appStateService.updateState({ themePrimary1 });
  }
  updateBackground(themeBackground: any) {
    this.appStateService.updateState({ themeBackground, menuColor: 'dark',headerColor:'transparent', theme:"dark" });
  }
  updateBgImage(backgroundImage: string) {
    this.appStateService.updateState({ backgroundImage, });
  }


  //primary theme change

  defaultPrimary = '#6c5ffc';
  public dynamicLightPrimary(data: any): void {
    this.defaultPrimary = data.color;
    let primaryColor = this.convertRgbToIndividual1(this.defaultPrimary)
    let primaryrgb = this.convertRgbToIndividual1(this.defaultPrimary)
    let bg1Update = primaryColor.replace(/,/g, ' ');
    let bg2Update: any = primaryrgb;
    let primarycolor:any = { primary1: bg1Update, primaryrgb: bg2Update, 
    }
    this.updateprimary1(primarycolor);
  }
  convertRgbToIndividual1(value: string): string {
    // Use a regular expression to extract the numeric values
    const numericValues = value.match(/\d+/g) || [];
    // Join the numeric values with spaces to get the desired format
    return numericValues.join(' , ');
  }
  //background theme change
  convertRgbToIndividual(value: string): string {
    // Use a regular expression to extract the numeric values
    const numericValues = value.match(/\d+/g) || [];
    // Join the numeric values with spaces to get the desired format
    return numericValues.join(' ');
  }

  public defaultBg = '#6c5ffc';
  public dynamicTranparentBgPrimary(data: any): void {
    this.defaultBg = data.color;
    let bgRgb = this.convertRgbToIndividual(this.defaultBg);
    let bgRgb2 = this.convertRgbToIndividual(this.defaultBg);
    let bg1Update = bgRgb;
    let bg2Update: any = bgRgb2.split(' ');
    bg2Update[0] = Number(bg2Update[0]) + 14;
    bg2Update[1] = Number(bg2Update[1]) + 14;
    bg2Update[2] = Number(bg2Update[2]) + 14;
    let bgColor = { main: bg1Update, secondary: bg2Update,
      accent: bg2Update, overlay: 'rgba(255,255,255,0.1)',
      theme: 'dark',
    }
    this.updateBackground(bgColor);
  }
  
  reset() {
    this.appStateService.applyReset();
  }
}

 
